import SportsIcon from "@material-ui/icons/Sports";
import { Resource } from "react-admin";
import { Route } from "react-router-dom";
import BusinessIcon from "@material-ui/icons/Business";
import PeopleIcon from "@material-ui/icons/People";

import { AppResource } from "../../../types/resource.types";
import Chat from "../../Chat";
import GymDashboard from "./Dashboard";
import AccountSettings from "../../AccountSettings";
import GymProfile from "../../Profiles/GymProfile";
import { GymPackagesCreate, GymPackagesEdit, GymPackagesList } from "../../Gym/Packages";
import { GymsReviewsList } from "../../Gym/Reviews";
import { GymMembersList } from "../../Gym/Members";
import GymManagement from "../../Gym/Management";
import GymFullNotificationList from "../../Gym/GymNotifications/GymFullNotificationList";

export const gymAccount = {
  resources: [
    <Resource
      name={AppResource.packages}
      list={GymPackagesList}
      edit={GymPackagesEdit}
      create={GymPackagesCreate}
      icon={BusinessIcon}
      options={{
        label: "Packages",
      }}
    />,
    <Resource
      name={AppResource.gymReviews}
      list={GymsReviewsList}
      icon={SportsIcon}
      options={{
        label: "Reviews",
      }}
    />,
    <Resource
      name={AppResource.subscribedGyms}
      list={GymMembersList}
      icon={PeopleIcon}
      options={{
        label: "Members",
      }}
    />,
    <Resource name={AppResource.clients} />,
  ],
  customRoutes: [
    <Route exact path={`/${AppResource.management}`} component={GymManagement} />,
    <Route exact path={`/${AppResource.settings}`} component={AccountSettings} />,
    <Route exact path={`/${AppResource.chat}/:roomId`} component={Chat} />,
    <Route exact path={`/${AppResource.notifications}`} component={GymFullNotificationList} />,
    <Route exact path={`/${AppResource.profile}`} component={GymProfile} />,
  ],
  dashboard: GymDashboard,
};
